export const EDITION_INTERVENTION = {
  title: {
    add: 'Ajout demande d\'intervention',
    edit: 'Modification demande d\'intervention {code}',
  },
  breadcrumb: {
    racine: 'Accueil',
    listeDemandeIntervention: 'Liste demandes interventions',
    nouvelleIntervention: 'Ajout demande intervention',
    edit: 'Modification demande intervention',
  },
  infoGenerale: {
    title: 'Informations générales',
    dateIntervention: 'Date d\'intervention souhaitée',
    typeIntervention: 'Type d\'intervention',
    demandeur: 'Demandeur',
    etat: 'Etat',
    source: 'Source',
    patrimoine: 'Patrimoine',
    adresse: 'Adresse',
    sujetDemande: 'Sujet de la demande',
    typeOt: 'Type d\'OT technique',
    OT: 'OT technique',
    dateLimite: 'Date limite',
    description: 'Description',
    tags: 'Tags',
    patrimoineInfo: {
      face: 'Face : {ref}',
      materiel: 'Matériel : {ref}',
      dispositif: 'Dispositif : {ref}',
      emplacement: 'Emplacement : {ref}',
      add: 'Associer un patrimoine',
    },
    addPatToDemande: {
      title: 'Ajouter un patrimoine à votre demande d\'intervention',
      breadcrumb: {
        add: 'Ajout patrimoine à une demande d\'intervention',
      },
    },
    canNotChangePatrionine: 'Impossible de changer le patrimoine car la demande est de type "Fabrication du dispositif" ou "Pose du dispositif fabriqué"',
  },
  interventionType: {
    affichage: 'Affichage',
    intervention: 'Intervention',
    nonDefini: 'Non défini',
  },
  interventionSource: {
    telephone: 'Par téléphone',
    mail: 'Par mail',
    autre: 'Autre',
    affixeMobile: 'Affixe Mobile',
    vente: 'Vente',
  },
  etatIntervention: {
    valide: 'Validé',
    nouveau: 'Nouveau',
    traite: 'Traité',
    refuse: 'Refusé',
  },
  success: {
    demandeAdd: 'Demande d\'intervention ajoutée avec succès.',
    demandeUpdate: 'Demande d\'intervention modifiée avec succès.',
  },
  error: {
    date: 'Date d\'intervention souhaitée',
    sujet: 'Sujet de la demande',
    demandeur: 'Demandeur',
    demandePereId: 'Demande de référence',
    agence: 'Agence',
    inOt: 'Impossible de modifier une demande logistique déjà dans un OT d\'affichage.',
  },
};

export const LISTE_DEMANDE_INTERVENTION = {
  title: 'Liste des demandes d\'intervention',
  breadcrumb: {
    home: 'Accueil',
    listeIntervention: 'Liste demandes intervention',
  },
  actions: {
    newIntervention: 'Nouvelle demande',
    search: 'Rechercher',
    fusion: 'Fusionner les demandes',
    voirDemandeEnfant: 'Demande(s) liée(s) ({nombre})',
  },
  filtre: {
    etat: 'Etat(s)',
    source: 'Source(s)',
    nDemande: 'N° de demande',
    type: 'Types(s)',
    date: 'Date',
    sujetDemande: 'Sujet de la demande',
    agence: 'Agence',
    patrimoineAdresse: 'Adresse',
    dateSouhaite: 'Date souhaité',
    demandeur: 'Demandeur(s)',
    typeOt: 'Type(s) OT technique',
    ville: 'Ville',
    codePostal: 'Code postal',
  },
  success: {
    demandeEtatEdit: 'Changement effectué avec succès',
  },
  tab: {
    etat: 'Etat',
    numeroDemande: 'N° de demande',
    date: 'Date',
    sujet: 'Sujet de la demande',
    agence: 'Agence(s)',
    patrimoine: 'Patrimoine',
    patrimoineAdresse: 'Adresse',
    dateSouhaite: 'Date souhaitée',
    type: 'Type',
    typeOt: 'Type OT technique',
    demandeur: 'Demandeur',
    source: 'Source',
    demandeLie: 'Demande liée(s)',
    otLie: 'OT lié',
    adresse: 'Adresse',
    ville: 'Ville',
    codePostal: 'Code postal',
    aucun: 'Aucune',
    annonceur: 'Annonceur',
  },
  demandeEnfant: {
    title: 'Demande(s) liée(s)',
  },
  fusion: {
    title: 'Sélectionner la demande de référence',
    tab: {
      nDemande: 'N° de demande',
      date: 'Date',
      sujetDemande: 'Sujet de la demande',
      demandeur: 'Demandeur',
      etat: 'Etat',
      type: 'Type',
      otLie: 'OT lié',
      agence: 'Agence(s)',
    },
    error: {
      typeDiff: 'Impossible de fusionner des demandes avec des types différents.',
      agenceDiff: 'Impossible de fusionner des demandes avec des agences différentes.',
    },
    info: {
      cantFusion: 'Vous devez avoir plusieurs demandes pour effectuer une fusion.',
    },
    etatFusion: 'Etat de la fusion',
  },
  etat: {
    traite: {
      title: 'Vous avez des ordres de travail techniques qui ne sont pas à l\'état "Réalisé"',
      sousTitle: 'Voulez-vous les passer automatiquement à l\'état "Réalisé" ?',
      successCreation: 'Changement de l\'état de la demande et des OT effectué avec succès.',
    },
    valide: {
      title: 'Vous n\'avez pas d\'ordre de travail technique lié à votre demande',
      sousTitle: 'Voulez-vous créer automatiquement un ordre de travail technique ?',
      successCreation: 'Changement de l\'état de la demande et création de l\'ordre de travail effectués avec succès.',
      goToOt: 'Aller sur l\'OT',
    },
  },
  error: {
    typeOt: 'Le type d\'OT technique est obligatoire pour créer un ordre de travail technique pour la demande {code}',
  },
};

export const DETAIL_INTERVENTION = {
  title: 'Détail demande d\'intervention {code}',
  breadcrumb: {
    detail: 'Détail demande intervention',
  },
  actions: {
    refuser: 'Refuser la demande',
    valider: 'Valider la demande',
    traiter: 'Traiter la demande',
  },
  infoGenerale: {
    title: 'Informations générales',
    dateIntervention: 'Date d\'intervention souhaitée :',
    typeIntervention: 'Type d\'intervention :',
    demandeur: 'Demandeur :',
    source: 'Source :',
    etat: 'Etat :',
    patrimoine: 'Patrimoine :',
    adresse: 'Adresse ',
    sujetDemande: 'Sujet de la demande ',
    typeOt: 'Type d\'OT technique :',
    agence: 'Agence :',
    OT: 'OT technique :',
    dateLimite: 'Date limite :',
    description: 'Description',
    tags: 'Tags',
    patrimoineInfo: {
      face: 'Face : {ref}',
      materiel: 'Matériel : {ref}',
      dispositif: 'Dispositif : {ref}',
      emplacement: 'Emplacement : {ref}',
    },
  },
  commande: {
    title: 'Commande',
    code: 'Code :',
    etat: 'Etat :',
    theme: 'Thème :',
    dateCampagne: 'Date de campagne :',
    annonceurs: 'Annonceur(s)  :',
    vente: 'Vente :',
    anneeSemaine: 'S{week} - {year}',
  },
  noAdresse: 'Aucune adresse liée à cette demande',
  etat: {
    traite: {
      title: 'Vous avez des ordres de travail techniques qui ne sont pas à l\'état "Réalisé"',
      sousTitle: 'Voulez-vous les passer automatiquement à l\'état "Réalisé" ?',
      successCreation: 'Changement d\'états de la demande et des OT effectués avec succès.',
    },
    valide: {
      title: 'Vous n\'avez pas d\'ordre de travail technique lié à votre demande',
      sousTitle: 'Voulez-vous créer automatiquement un ordre de travail technique ?',
      successCreation: 'Changement de l\'état de la demande et création de l\'ordre de travail effectués avec succès.',
      goToOt: 'Aller sur l\'OT',
    },
    refuser: {
      success: 'Changement de l\'état de la demande effectué avec succès.',
    },
  },
  error: {
    typeOt: 'Le type d\'OT technique est obligatoire pour créer un ordre de travail technique',
    technicWorkOrdreProduct: 'La société ne contient pas de produit d\'OT technique',
  },
  libelleForLogo: 'Demande d\'intervention {code}',
};
